<template>
  <t-data-table
    data-test-id="cloud-keys-data-table"
    class="mb-6"
    :loading="loading"
    :title="this.$t('All Cloud Keys')"
    :filter-placeholder="$t('Search Cloud Keys')"
    hoverable
    with-filter
    :table-data="cloudKeys"
    :actions="tableActions"
    user-role="customer"
    @on-delete="onDelete"
    @on-export="onExport"
    @on-add="onAdd"
    @on-row-clicked="onRowClicked"
    :searchExports="searchExports"
    @export-headers="exportedHeaders"
  />
</template>

<route>
{
  "name": "Customer Cloud Keys"
}
</route>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  layout: "customer",
  data() {
    return {
      loading: true,
      currentHeaders: null,

      searchExports: ["logname", "active"],
      tableActions: {
        add: {
          enabled: true,
          actions: [
            {
              text: this.$t("Create Cloud Key"),
              value: {
                title: this.$t("Create a Cloud Key"),
                modal: "t-cloud-keys",
              },
            },
          ],
        },
        export: { enabled: true },
        import: { enabled: false },
        delete: { enabled: true },
      },
      cloudKeys: {
        fields: [
          { value: "logname", text: this.$t("Log Name"), sortable: true },
          { value: "keyid", text: this.$t("Key"), sortable: true },
          {
            value: "expiresafter",
            text: this.$t("Expires After"),
            sortable: true,
          },
          { value: "validfrom", text: this.$t("Valid From"), sortable: true },
          { value: "validto", text: this.$t("Valid To"), sortable: true },
          { value: "active", text: this.$t("Status"), sortable: true },
        ],
        items: [],
      },
      internalUsers: [],
    };
  },
  watch: {
    keys() {
      this.cloudKeys.items = this.cleanCloudKeyData(this.keys);
    },
  },
  computed: {
    ...mapGetters("cloudKeys", ["keys"]),
    ...mapGetters("authentication", ["selectedUser"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("cloudKeys", [
      "fetchCustomerCloudKeys",
      "deleteCustomerCloudKeys",
    ]),
    ...mapMutations("modal", ["createModal", "showModal"]),
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onAdd({ title, modal }) {
      this.createModal({
        modal,
        title,
        dataTestId: "modal-cloud-keys",
        subtitle: this.selectedUser.accountname,
        props: {
          size: "lg",
          okTitle: this.$t("Create Cloud Key"),
        },
      });

      this.showModal();
    },
    async onDelete(cloudKeys) {
      try {
        await this.deleteCustomerCloudKeys({
          userId: this.selectedUser.id,
          cloudKeys,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Deleted: X", { item: cloudKeys.length }),
          duration: 2000,
          variant: "success",
        });
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      }
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });
          return payload;
        });
        this.$downloadCSV(exportData, "cloudkeys");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No Cloudkeys in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
    cleanCloudKeyData(cloudKeys) {
      return cloudKeys.map((cloudkey) => {
        return {
          ...cloudkey,
          expiresafter: `${cloudkey.expiresafter} ${cloudkey.expiresafterperiod}`,
          active: cloudkey.active ? this.$t("Active") : this.$t("Inactive"),
        };
      });
    },
    onRowClicked(item) {
      this.$router.push({
        path: `/customer/content_filtering/cloud_keys/${item.id}`,
      });
    },
  },
  async created() {
    this.setPageTitle(this.$t("Cloud Keys"));
    this.setPageSubtitle([
      this.$t(
        "Cloud keys let a user view blocked content using a cloud key you create for them. After entering a cloud key on a block page, a user can view the blocked content."
      ),
    ]);

    await this.fetchCustomerCloudKeys({ id: this.selectedUser.id });
    this.loading = false;
  },
};
</script>
